import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import FieldConfigContainer from '../../containers/fieldconfigmng/FieldConfigContainer';

const FieldConfigPage = () => {
  return (
    <div>
      <BreadcrumbsContainer 
        title="시스템관리/필드설정관리/필드 사용 설정" 
        icon="settings"
      />
      <FieldConfigContainer />
    </div>
  );
};

export default FieldConfigPage;
